"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FETCH_PLAYBOOK_CANCEL = exports.FETCH_PLAYBOOK_FAILED = exports.FETCH_PLAYBOOK_SUCCESS = exports.FETCH_PLAYBOOK_REQUEST = void 0;
exports.FETCH_PLAYBOOK_REQUEST = '@teams/FETCH_PLAYBOOK_REQUEST';
exports.FETCH_PLAYBOOK_SUCCESS = '@teams/FETCH_PLAYBOOK_SUCCESS';
exports.FETCH_PLAYBOOK_FAILED = '@teams/FETCH_PLAYBOOK_FAILED';
exports.FETCH_PLAYBOOK_CANCEL = '@teams/FETCH_PLAYBOOK_CANCEL';